import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { Message } from 'primeng/api';
import { AuthService } from 'src/app/service/auth.service';
import { CustomValidator } from 'src/shared/custom-validator';
import { CognitoException } from 'src/app/model/enum/cognito-exception';
import { Language } from 'src/app/model/language';
import { LANGUAGE_LIST } from 'src/app/model/mockup/language-mockup';
import { LanguageEnum } from 'src/app/model/enum/language-enum';
import { GeolocationService } from 'src/app/service/geolocation.service';

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrl: './activate-account.component.css'
})
export class ActivateAccountComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  public form!: FormGroup;

  name: string | null = null;
  email: string = '';
  code: string = '';
  isLoading: boolean = false;
  isDivCreate: string;
  isDivActivated: string;
  isDivExpired: string;
  /** Conta já estava ativada quando o usuário chegou aqui: troca só o título da tela de sucesso. */
  alreadyConfirmed: boolean = false;
  loginUrl: string;
  createAccountUrl: string;
  messagesCode: Message[] = [];

  languageOptions: Language[];
  DEFAULT_LANGUAGE: Language;
  language: Language;

  countdown: number = 60; 
  isButtonDisabled: boolean = true;
  private intervalId: any;

  constructor(private formBuilder: FormBuilder, 
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translocoService: TranslocoService,
    private authService: AuthService,
    private geolocationService: GeolocationService,
    private route: ActivatedRoute) {

    this.isDivCreate='none';
    this.isDivActivated='none'; //none
    this.isDivExpired='none'; //none

    this.loginUrl = '/login';
    this.createAccountUrl = '/create-account';

    

    this.languageOptions = LANGUAGE_LIST as [];
  // Fallback EN_US
  this.DEFAULT_LANGUAGE = this.languageOptions[1];
    this.language = this.DEFAULT_LANGUAGE;
  }

  ngOnInit(): void {
    const rawStored = sessionStorage.getItem('language');
    const lanStored = this.normalizeLanguage(rawStored);
    this.createForm(this.code);
    if (rawStored === LanguageEnum.PT_BR || rawStored === LanguageEnum.EN_US || rawStored === LanguageEnum.ES_ES) {
      sessionStorage.setItem('language', lanStored);
      this.language = this.getLanguage(lanStored);
      this.changeLanguage(this.language.name);
    } else {
      // sem idioma válido salvo -> tenta geolocalização
      this.language = this.DEFAULT_LANGUAGE;
      this.changeLanguage(this.language.name);
      this.getLocation();
    }
    this.refreshLanguageOptions();
    this.setTitle();
    this.email = sessionStorage.getItem('email-activate-account') || '';
    sessionStorage.removeItem('email-activate-account');
    this.name = sessionStorage.getItem('name-activate-account') || null;
    sessionStorage.removeItem('name-activate-account');
    this.startCountdown();
    // this.name = this.router.getCurrentNavigation()?.extras.state?.['name'];
    // let email = this.router.getCurrentNavigation()?.extras.state?.['email'];
    // if(email !== null) {
    //   this.email = email;
    // } else {
    //   this.router.navigate([this.loginUrl]);
    // }


    this.route.queryParams.subscribe(params => {
     

      if(params['code'] !== undefined && params['email'] !== undefined) {
        this.code = params['code']; // pega ?code=...
        this.email = params['email']; // pega ?email=...

        if(this.code && this.code.length === 6 && this.email && this.email.length > 0) {
          this.isLoading = true;

          this.onSubmit();
        }else{
          this.isDivCreate = "";
        }
      }else{
        this.isDivCreate = "";
      }


      
    });
  }

  startCountdown(): void {
    this.isButtonDisabled = true;
    this.countdown = 60;

    this.intervalId = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.isButtonDisabled = false;
        clearInterval(this.intervalId);
      }
    }, 1000);
  }

  createForm(code: string) {
    this.form = this.formBuilder.group({
      code: [code, CustomValidator.getRequired()],
      language: [sessionStorage.getItem("language") ?? 'en-us']
    })
  }

  onSubmit() {
    this.authService.confirmSignUp(this.email, this.code).then(result => {
        this.isLoading = false;  
        this.showActivated(result.alreadyConfirmed === true);
    }).catch(error => {
      this.isLoading = false;
      let messageError = '';
      this.isDivCreate = "";
      this.translocoService.selectTranslateObject('cognito.insuccess').subscribe(value =>{
        if(CognitoException.NOT_AUTHORIZED === error.name)
          messageError = value.NotAuthorizedException;
        if(CognitoException.USER_NOT_CONFIRMED === error.name)
          messageError = value.UserNotConfirmedException;
        if(CognitoException.NETWORKING_ERROR === error.name)
          messageError = value.NetworkingError;
        if(CognitoException.CODE_MISMATCH === error.name)
          messageError = value.CodeMismatchException;
        if(CognitoException.EXPIRED_CODE === error.name)
          messageError = value.ExpiredCodeException;

        if(messageError.length< 1)
          messageError = error;

        this.messagesCode = [{ severity: 'error', summary: messageError }]
      }).unsubscribe();
    });
  }

  sendEmailAgain() {
    if (!this.isButtonDisabled) {
      this.authService.resendConfirmationCode(this.email).then((result) => {
        if (result?.alreadyConfirmed) this.showActivated(true);
      }).catch(() => {
        this.translocoService.selectTranslate('errorConection').pipe(take(1)).subscribe(value => this.messagesCode = [
          { severity: 'error', summary: value}
        ]);
      });
      this.startCountdown();
    }
  }

  redirect() {
    this.router.navigate([this.loginUrl]);
  }

  expired() {
    this.router.navigate([this.createAccountUrl]);
  }

  showCreate() {
    this.isDivCreate = "none";
    this.isDivActivated = "none";
    this.isDivExpired="none";
  }

  showActivated(alreadyConfirmed: boolean = false) {
    this.alreadyConfirmed = alreadyConfirmed;
    this.isDivCreate = "none";
    this.isDivActivated = "";
    this.isDivExpired="none";
    setTimeout(() => {
          var pass = sessionStorage.getItem("pass");
          if(!pass){
            this.router.navigate([this.loginUrl]);
          }else{
            const payload = `${this.email}:${pass}`;

            // Converte para Base64
            const encoded = btoa(payload);
            //limpa a senhaa do storage que foi usada apenas para redirect antes de ativar a conta e logar automaticamente
            sessionStorage.setItem("pass", "");
            // Redireciona com query param
            this.router.navigate([this.loginUrl], { queryParams: { code: encoded } });
          }
          
    }, 5000);  //5s
  }

  showExpired() {
    this.isDivCreate = "none";
    this.isDivActivated = "none";
    this.isDivExpired="";
  }
  
  setTitle() {
    this.translocoService.selectTranslate('title.activate-account').pipe(takeUntil(this.destroy$)).subscribe(value => 
      this.titleService.setTitle(value)
    );
  }

  selectLanguage(selected: Language) {
    this.f.language.setValue(selected);
    this.fixLanguage();
  }

  fixLanguage() {
    this.language = this.f.language.value;
    if (this.translocoService.getActiveLang() !== this.language.name) {
      this.languageOptions
        .filter((opt) => opt.name === this.language.name)
        .map((cty) => (cty.disabled = true));
      this.languageOptions
        .filter((opt) => opt.name !== this.language.name)
        .map((cty) => (cty.disabled = false));

      this.changeLanguage(this.language.name);
      sessionStorage.setItem("language", this.language.name);
    }
  }

  getLanguage(lan: string | null) : Language {
    for (let i = 0; i < this.languageOptions.length; i++) {
      if(this.languageOptions[i].name === lan) {
        return this.languageOptions[i];
      }
    }
    return this.DEFAULT_LANGUAGE;
  }

  private normalizeLanguage(lan: string | null): string {
    const allowed = [LanguageEnum.PT_BR, LanguageEnum.EN_US, LanguageEnum.ES_ES];
    if (!lan || !allowed.includes(lan as LanguageEnum)) return LanguageEnum.EN_US;
    return lan as string;
  }

  public changeLanguage(languageCode: string | null): void {
    if(languageCode !== null)
      this.translocoService.setActiveLang(languageCode);
  }

  getLocation(){
    this.geolocationService.getCountry().subscribe({
      next: (data: any) => {
        // Só ajusta se ainda não foi definida por sessionStorage válido
        if (!(sessionStorage.getItem('language') === LanguageEnum.PT_BR || sessionStorage.getItem('language') === LanguageEnum.EN_US || sessionStorage.getItem('language') === LanguageEnum.ES_ES)) {
          if (data.country_code === "BR") {
            this.language = this.languageOptions[0];
          } else {
            this.language = this.languageOptions[1];
          }
          sessionStorage.setItem('language', this.language.name);
          this.changeLanguage(this.language.name);
          this.refreshLanguageOptions();
        }
      },
      error: (_) => {
        if (!(sessionStorage.getItem('language') === LanguageEnum.PT_BR || sessionStorage.getItem('language') === LanguageEnum.EN_US || sessionStorage.getItem('language') === LanguageEnum.ES_ES)) {
          this.language = this.DEFAULT_LANGUAGE;
          sessionStorage.setItem('language', this.language.name);
          this.changeLanguage(this.language.name);
          this.refreshLanguageOptions();
        }
      }
    });
  }

  refreshLanguageOptions() {
    for (let i = 0; i < this.languageOptions.length; i++) {
      if(this.languageOptions[i].name === this.language.name)
        this.languageOptions[i].disabled = true;
      else
       this.languageOptions[i].disabled = false;
    }
  }


  get asideKey(): string {
    if (this.isDivActivated === '') return 'user.authAside.activateAccount.activated';
    if (this.isDivExpired === '') return 'user.authAside.activateAccount.expired';
    return 'user.authAside.activateAccount.sent';
  }

  get f() { return this.form.controls; }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
